import React from 'react';

export type FeatureFlags = Record<string, boolean>;

export default React.createContext<FeatureFlags>({});
